// This is generated.  Alter it in blockGroups/formElements/types/MultiPickerSensorGrid.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { id, title, propertyName } = hNode;

    // Process children (list columns) to extract any sub data dictionary info
    let [subDataDictionary = {}, _partialTypeDefinition = {}] =
      hNode.children?.reduce(
        ([sdd, ptd], child) => {
          const [_subDataDictionary = {}, _partialTypeDefinition = {}] =
            context.extractFromChild(child, context);
          return [
            merge(sdd, _subDataDictionary),
            moduleRegistration.mergePartialTypeDefinitions(
              ptd,
              _partialTypeDefinition,
            ),
          ];
        },
        [{}, {}],
      ) ?? [{}, {}];

    // MultiPickerSensorGrid items can contain various properties from sensor reads
    // Use additionalProperties: true to allow any properties on items
    const itemSchema = Type.Object(_partialTypeDefinition, {
      title: 'Item',
      'x-dataType': 'object',
      additionalProperties: true,
    });

    // MultiPickerSensorGrid is always optional and editable
    const arraySchema = Type.Optional(
      Type.Array(itemSchema, {
        title: title,
        'x-id': id,
        'x-dataType': 'array',
        'x-propertyName': propertyName,
        'x-optional': true,
        'x-editable': true,
      }),
    );

    // The partial type definition uses the propertyName from the block
    const partialTypeDefinition = {
      [propertyName]: arraySchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'MultiPickerSensorGrid',
  module.exports,
);
